import httpService from "./httpService";
import utils from "./utils";

export default {
  count(usingAdvanceSearch, keyword, status, form, fromDocDate, toDocDate) {
    var params = utils.merge(
      {
        usingAdvanceSearch: usingAdvanceSearch,
        keyword: keyword,
        status: status,
        fromDocDate: fromDocDate,
        toDocDate: toDocDate
      },
      form
    );

    return httpService.get("/vbIncomingDocUserView/count", { params: params });
  },


  findAll(usingAdvanceSearch, keyword, status, form, pageable, fromDocDate, toDocDate, relationType) {
    pageable = utils.initPageableParams(pageable);
    var params = utils.merge(
      utils.merge(
        {
          usingAdvanceSearch: usingAdvanceSearch,
          keyword: keyword,
          status: status,
          fromDocDate: fromDocDate,
          toDocDate: toDocDate,
          relationType: relationType
        },
        form
      ),
      pageable
    );

    return httpService.get("/vbIncomingDocUserView", { params: params });
  },

  findAllV2(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("/vbIncomingDocUserView", { params: params });
  },
  exportSearchResult(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable)
    return httpService.get("/vbIncomingDocUserView/exportSearchResult", {params: params});
  },

  findByDocId(docId, params) {
    // let params = utils.merge({docId: docId});
    return httpService.get(
      "/vbIncomingDocUserView/findByDocId/" + docId,
      params
    );
  },

  findByDocIdAndUserDeptRoleId(docId, userDeptRoleId) {
    let params = utils.merge({ userDeptRoleId: userDeptRoleId });
    return httpService.get(
      "/vbIncomingDocUserView/findByDocIdAndUserDeptRoleId/" + docId,
      { params: params }
    );
  },

  findAllToTrinhQuaHan(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("/vbIncomingDocUserView/findAllToTrinhQuaHan", {
      params: params
    });
  },

  findAllToTrinhQuaHanCount(form) {
    return httpService.get(
      "/vbIncomingDocUserView/findAllToTrinhQuaHan/count",
      { params: form }
    );
  },

  findAllByBlockedRole(form, pageable, userDeptRoleId) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      {
        userDeptRoleId: userDeptRoleId
      },
      form
    );
    params = utils.merge(params, pageable);
    return httpService.get("/vbIncomingDocUserView/findAllByBlockedRole", {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/vbIncomingDocUserViewService.js